export interface StringObj {
    [k: string]: string;
}

export class Cookies {
    data: StringObj = {};

    constructor(private doc: Document) {
        this.parse();
    }

    private parse() {
        this.data = parseKVString(this.doc.cookie, "; ");
    }

    get(key: string) {
        return this.data[key];
    }

    set(key: string, value: string, days = 7) {
        const date = new Date();
        date.setDate(date.getDate() + days);
        this.doc.cookie = `${key}=${escape(value)}; expires=${date.toUTCString()}; path=/`;
        this.parse();
    }

    del(key: string) {
        this.set(key, "", -1);
    }
}

export function parseKVString(kvStr: string, delimiter: string, kvSplit = "=") {
    return kvStr
        .split(delimiter)
        .map(kv => {
            const inx = kv.indexOf(kvSplit);
            const pos = inx >= 0 ? inx : kv.length;
            return [kv.slice(0, pos), kv.slice(pos + 1)];
        })
        .reduce((p, [k, v]) => ({ ...p, [k]: v }), {} as StringObj);
}
